import React, { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCartShopping, faHeart, faMicrophone, faSearch } from '@fortawesome/free-solid-svg-icons';
import './Navbar2.css';
import { useCart } from '../context/CartContext';
import { useWishlist } from '../context/WishlistContext';
import tfcLogo from '../assets/TCF_logo.png';

function Navbar2() {

    const [activeMainCategory, setActiveMainCategory] = useState("Women's Wear");
    const [showDropdown, setShowDropdown] = useState(false);
    const [activeMainBrand, setActiveMainBrand] = useState("Women's Wear");
    const [showBrandDropdown, setShowBrandDropdown] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [departments, setDepartments] = useState([]);
    const [categories, setCategories] = useState({});
    const [brandsByDepartment, setBrandsByDepartment] = useState({});
    const [loading, setLoading] = useState(true);

    const navigate = useNavigate();
    const { cartItems } = useCart();
    const { wishlistItems } = useWishlist();

    const handleSearch = (e) => {
        e.preventDefault();
        if (searchQuery.trim()) {
            navigate(`/search?q=${encodeURIComponent(searchQuery)}`);
        }
    };

    const handleCategoryClick = (category) => {
        const encodedCategory = encodeURIComponent(category);
        navigate(`/category/${encodedCategory}`);
        setShowDropdown(false);
    };

    const handleBrandClick = (brand) => {
        const encodedBrand = encodeURIComponent(brand);
        navigate(`/brand/${encodeURIComponent(encodedBrand)}`);
        setShowDropdown(false);
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                // Fetch departments
                const deptResponse = await fetch('http://localhost:3001/api/departments');
                const depts = await deptResponse.json();
                setDepartments(depts);

                // Fetch categories for each department
                const cats = {};
                for (const dept of depts) {
                    const catResponse = await fetch(`http://localhost:3001/api/categories?department=${encodeURIComponent(dept)}`);
                    const deptCats = await catResponse.json();
                    cats[dept] = deptCats;
                }
                setCategories(cats);

                const brandsByDept = {};
                for (const dept of depts) {
                    const brandResponse = await fetch(`http://localhost:3001/api/brands?department=${encodeURIComponent(dept)}`);
                    const brandData = await brandResponse.json();
                    brandsByDept[dept] = brandData;
                }
                setBrandsByDepartment(brandsByDept);

                setLoading(false);
            } catch (error) {
                console.error("Error fetching data:", error);
                setLoading(false);
            }
        };

        fetchData();
    }, []);




    if (loading) {
        return <div className="navbar2-container">Loading...</div>;
    }


    return (
        <div className="navbar2-container">
            <div className="navbar2-content">
                <Link className="navbar-brand" to="/home">
                    <img
                        src={tfcLogo}
                        alt="Tata CLiQ Luxury"
                        className="navbar-logo"
                    />
                </Link>
                <nav className="navbar2-nav navbar-expand-lg navbar-dark ">
                    <div className="container-fluid">
                        <div className="d-flex align-items-center w-100">
                            <ul className="navbar-nav">
                                <li className="nav-item dropdown"
                                    onMouseEnter={() => setShowDropdown(true)}
                                    onMouseLeave={() => setShowDropdown(false)}
                                >
                                    <Link className="nav-link dropdown-toggle" to="#" role="button">
                                        Categories
                                    </Link>

                                    {showDropdown && (
                                        <div className="category-dropdown">
                                            <div className="dropdown-columns">
                                                <div className="main-categories">
                                                    {departments.map((department) => (
                                                        <div
                                                            key={department}
                                                            className={`main-category ${activeMainCategory === department ? 'active' : ''}`}
                                                            onMouseEnter={() => setActiveMainCategory(department)}
                                                        >
                                                            {department}
                                                            <span className="arrow-icon">→</span>
                                                        </div>
                                                    ))}
                                                </div>

                                                <div className="subcategories">
                                                    <h5>{activeMainCategory}</h5>
                                                    <div className="subcategory-list">
                                                        {categories[activeMainCategory]?.map((category) => (
                                                            <div
                                                                key={category}
                                                                onClick={() => handleCategoryClick(category)}
                                                                className="subcategory-item"
                                                                style={{ cursor: 'pointer' }}
                                                            >
                                                                {category}
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </li>

                                <li className="nav-item dropdown"
                                    onMouseEnter={() => setShowBrandDropdown(true)}
                                    onMouseLeave={() => setShowBrandDropdown(false)}
                                >
                                    <Link
                                        className="nav-link dropdown-toggle"
                                        to="#"
                                        role="button"
                                    >Brands</Link>

                                    {showBrandDropdown && (
                                        <div className="category-dropdown">
                                            <div className="dropdown-columns">
                                                <div className="main-categories">
                                                    {departments.map((department) => (
                                                        <div
                                                            key={department}
                                                            className={`main-category ${activeMainBrand === department ? 'active' : ''}`}
                                                            onMouseEnter={() => setActiveMainBrand(department)}
                                                        >
                                                            {department}
                                                            <span className="arrow-icon">→</span>
                                                        </div>
                                                    ))}
                                                </div>
                                                <div className="subcategories">
                                                    <div className="subcategory-list">
                                                        {brandsByDepartment[activeMainBrand]?.map((brand) => (
                                                            <div
                                                                key={brand}
                                                                className="subcategory-item"
                                                                onClick={() => handleBrandClick(brand)}
                                                                style={{ cursor: 'pointer' }}
                                                            >
                                                                {brand}
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </li>
                            </ul>
                            <div className="d-flex align-items-center ms-auto">
                                {/* <form className="d-flex me-3" onSubmit={handleSearch}>
                                    <div className="input-group" style={{ maxWidth: "400px" }}>
                                        <span className="input-group-text bg-transparent position-absolute start-0 ps-3 border-0 z-index-1"><FontAwesomeIcon icon={FaSearch}/></span>
                                        <input
                                            className="form-control ps-5 pe-5"
                                            type="search"
                                            placeholder="Search for products, brands..."
                                            aria-label="Search"
                                            value={searchQuery}
                                            onChange={(e) => setSearchQuery(e.target.value)}
                                            style={{ paddingLeft: "2.5rem", paddingRight: "2.5rem" }}
                                        />
                                        <button className="btn btn-outline-light" type="submit">
                                            <FontAwesomeIcon icon={faSearch} />
                                        </button>
                                    </div>
                                </form> */}

                                <form className="d-flex me-3" onSubmit={handleSearch}>
                                    <div className="search-container">
                                        {/* Search Icon - Left Side */}
                                        <span className="search-icon">
                                            <FontAwesomeIcon icon={faSearch} />
                                        </span>

                                        {/* Input Field */}
                                        <input
                                            className="search-input"
                                            type="search"
                                            placeholder="Search for products, brands..."
                                            aria-label="Search"
                                            value={searchQuery}
                                            onChange={(e) => setSearchQuery(e.target.value)}
                                        />

                                        {/* Mic Icon - Right Side */}
                                        <button className="mic-icon" type="button">
                                            <FontAwesomeIcon icon={faMicrophone} />
                                        </button>
                                    </div>
                                </form>
                                <div className="d-flex">
                                    <Link to="/wishlist" className="nav-link text-white me-3 position-relative">
                                        <FontAwesomeIcon icon={faHeart} size="lg" />
                                        {wishlistItems.length > 0 && (
                                            <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                                                {wishlistItems.length}
                                            </span>
                                        )}
                                    </Link>
                                    <Link to="/cart" className="nav-link text-white position-relative">
                                        <FontAwesomeIcon icon={faCartShopping} size="lg" />
                                        {cartItems.length > 0 && (
                                            <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                                                {cartItems.length}
                                            </span>
                                        )}
                                    </Link>
                                </div>
                            </div>
                        </div>



                    </div>
                </nav>
            </div>
        </div>
    )
}

export default Navbar2